import { DataSummary } from './data-summary.js'
import { DataSummaryQuery } from './data-summary-query.js'
import { DataSummaryMutation } from './data-summary-mutation.js'

export const entities = [DataSummary]
export const resolvers = [DataSummaryQuery, DataSummaryMutation]
export const subscribers = []
